import { ILeukemiaSubtypes, IMolecularConfirmation } from '@/types/MolecularConfirmation.types';

export const changeOrRefinementOptions = [
  'No change required',
  'Yes, change in diagnosis',
  'Yes, refinement in diagnosis',
  'Other scenario (see notes)',
] as const;

export const pathologistAgreementOptions = [
  'Yes, agrees/has changed',
  'No, does not agree',
  'N/A',
] as const;

export const leukeamiaSubtypeOptions = [
  'APL',
  'BCL11B',
  'BCL11B rearranged',
  'BCR::ABL1',
  'CBFB::MYH11',
  'CBFB-GDXY',
  'CDX2/UBTF',
  'CEBPA',
  'CH-related',
  'DEK::NUP214',
  'dic(9;20)',
  'DUX4 rearranged',
  'ETP-like',
  'ETP-like ETV6',
  'ETP-like HOXA13',
  'ETP-like KMT2A',
  'ETP-like MED12',
  'ETP-like MLLT10',
  'ETP-like NUP214',
  'ETP-like NUP98',
  'ETP-like Rare',
  'ETP-like ZFP36L2',
  'ETS family',
  'ETV6::RUNX1',
  'ETV6::RUNX1-like',
  'GATA1',
  'GATA3 enriched',
  'GLIS rearranged',
  'HOX rearranged',
  'HOXA9 rearranged',
  'Hyperdiploid',
  'Hypodiploid',
  'iAMP21',
  'IGH rearranged',
  'IGH::IL3',
  'IKZF1 N159Y',
  'KAT6A rearranged',
  'KMT2A rearranged',
  'KMT2A-PTD',
  'MECOM',
  'MEF2D rearranged',
  'MLLT10 rearranged',
  'MNX1',
  'MYC rearranged',
  'Near haploid',
  'Near tetraploid',
  'NKX2-1 rearranged',
  'NKX2-5 rearranged',
  'NPM1',
  'NUP214 rearranged',
  'NUP98 rearranged',
  'NUTM1 rearranged',
  'PAX5 P80R',
  'PAX5alt',
  'Ph-like',
  'Ph-positive',
  'PICALM::MLLT10',
  'RBM15::MRTFA',
  'RUNX1::RUNX1T1',
  'SPI1 rearranged',
  'STAG2/LMO2 rearranged',
  'TAL1 DP-like',
  'TAL1 DP-like JAK',
  'TAL1 DP-like LEF1/LYL',
  'TAL1 DP-like Other',
  'TAL1 DP-like RPL10',
  'TAL1 αβ-like',
  'TAL1 αβ-like Loss 6q',
  'TAL1 αβ-like NOTCH WT',
  'TAL1 αβ-like Other',
  'TCF3::HLF',
  'TCF3::PBX1',
  'TLX1 rearranged',
  'TLX3 DP-like',
  'TLX3 immature',
  'TLX3 rearranged',
  'TME-enriched',
  'UBTF',
  'Unclassified/rare',
  'ZEB2/CEBP',
  'ZNF384 group',
  'Unknown',
  'N/A',
] as const;

export const defaultMolecularConfirmation: IMolecularConfirmation = {
  changeOrRefinement: 'No change required',
  changeOrRefinementNotes: null,
  pathologistAgreement: 'N/A',
  pathologistCommunicationMethod: null,
  pathologistAgreementNotes: null,
  finalDiagnosisUpdated: false,
};

export const defaultLeukemiaSubtypes: ILeukemiaSubtypes = {
  diagnosisSubtype: null,
  zero2ConfirmedSubtype: null,
};
